module.exports = __webpack_public_path__ + "img/correction.2db63684.svg";